import { Link, useLocation } from "react-router-dom";
import Details from "./Details";
import Options from "./Options";

const ListingCard = ({
  title = "Toyota Fortuner D-D4D 4BY4",
  className = "",
  imageUrls = [],
  description = "Lorem ipsum dolor sit amet consectetur. Habitant magna et volutpat consectetur. Diam vestibulum rutrum odio amet massa nibh eget tellus.",
  biddingTime = null,
}) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div
      className={`box-border grid grid-cols-5 overflow-hidden rounded-lg border border-lightGray ${className}`}
    >
      <picture className="aspect-square">
        <img
          src="/assets/images/products/product1.png"
          alt=""
          className="aspect-square h-[255px] w-full object-cover"
        />
      </picture>

      <div
        className={`col-span-3 flex grow flex-col items-start px-8 pt-6 pb-4 ${
          path.includes("reviews") ? "justify-start" : "justify-between"
        }`}
      >
        <div>
          <Link to="/auctionlisting">
            <h3 className="font-pop text-xl font-bold text-darkGreen">
              {title || ""}
            </h3>
          </Link>
          <p className="mt-2 mb-4 flex w-4/5 items-end gap-1 font-pop text-sm font-normal text-cardSecondaryColor">
            {description || ""}
          </p>
        </div>
        <Details />
      </div>
      <Options biddingTime={biddingTime} />
    </div>
  );
};

export default ListingCard;
